import SidePanelHeader from "../components/SidePanelHeader"
import SidePanelSensitiveInfo from "../components/SidePanelSensitiveInfo"
import { EntityNames } from "../../../../../enums/EntityNames"
import { useNavigate } from "react-router"
import * as Navigation from "../../../../../modules/Navigation";
import SidePanelBreadCrumb from "../components/SidePanelBreadCrumb"
import SidePanelInfo from "../components/SidePanelInfo"
import { useEffect, useState } from "react"
import { httpGet } from "../../../../../modules/Backend"
import SidePanelNavLink from "../components/SidePanelNavLink"
import { hasPermission } from "../../../../../modules/auth/Permissions/PermissionModule";
import { PermissionConcerns, PermissionTypes } from "../../../../../modules/auth/Permissions/PermissionStrings";
import { usePermissions } from "../../../../../modules/auth/Permissions/PermissionContext"
import { getStatus } from "../../../../../enums/Domain/StatusLookup";
import ActionBar from "../actions/ActionBar";
import EditAction from "../actions/EditAction";
import { hasVisibleChildren } from "../../../entityComponents/Schema";

export default function SidePanelSpecimens({ data, onViewPage }: any) {
    const navigate = useNavigate()
    const [location, setLocation] = useState<string>("")
    const permissionsContext = usePermissions();

    function viewEntity() {
        // Only navigate if there are visible children
        if (hasVisibleChildren(data.entityName, permissionsContext)) {
            Navigation.view.navigate(navigate, data.entityName, data.id, data)
        }
    }

    async function getLocation(){
        const result = await httpGet(`api/specimens/location?id=${data.id}`)
        if(result?.data?.breadcrumb){
            setLocation(result.data.breadcrumb)
        }
    }

    function getFoundStatus() {
        if(data?.foundStatus === null || data?.foundStatus === undefined) {
            return '';
        }
        const status = getStatus(data.foundStatus);
        return status?.displayValue;
    }

    useEffect(() => {
        getLocation()
    }, [data])

    return (<>
        {data &&
            <>
                {!onViewPage && <SidePanelHeader descriptor="Specimen" value={data.specimenCode} statuses={data.status} onClick={(() => { viewEntity() })} />}
                <ActionBar>
                    {hasPermission(permissionsContext.permissions!, PermissionTypes.write, PermissionConcerns.Edit_Specimen) && 
                        <EditAction id={data.id} entityName={data.entityName} />}
                </ActionBar>
                <SidePanelInfo
                    values={[
                        { label: "Year", value: data.year },
                        { label: "Account", value: data.accountName },
                        { label: "Type", value: data.type },
                        { label: "Found Status", value: getFoundStatus() },
                        { label: "Quantity", value: data.quantity ?? "Unknown" },
                    ]}
                />
                <SidePanelBreadCrumb descriptor="Current location" value={location} />
                <SidePanelNavLink title="Case Number" value={data.caseCode} entityName={EntityNames.cases} entityId={data.caseId}/>
                {hasPermission(permissionsContext.permissions!, PermissionTypes.read, PermissionConcerns.PII_Notes) ? <SidePanelSensitiveInfo descriptor="Notes" data={data} dataTarget="notes" /> : null}
            </>
        }
    </>)
}